export default "__VITE_ASSET__fddc234c__"